module.exports = __webpack_public_path__ + "static/media/profile-completion-img.3aa46e7d.svg";